import { IconTag, lighterVariations, primaryColors, secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

export const StyledTitleText = styled.h1`
  color: ${({ theme }) => theme.colors.grey[100]};
  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  margin-right: 0.6rem;
  margin-bottom: 0rem;
  svg {
    margin-right: 1rem;
  }
`;

export const StyledIconTag = styled(IconTag)`
  background: ${lighterVariations.green.dark};
  color: ${secondaryColors.grey[100]};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  min-height: 3rem;
  svg {
    font-size: 1.2rem;
    color: ${primaryColors.main};
  }
`;
